import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import Routes from 'consts/routes';
import { BoxWrapper, Button } from 'components/Base';
import LoaderSpinner from 'components/LoaderSpinner/LoaderSpinner';
import { createStyles, makeStyles } from '@material-ui/core';
import { itemHoverColor, secondaryText } from 'utils/colors';
import api from 'api';
import moment from 'moment';
import CreateNewFolderIcon from '@material-ui/icons/CreateNewFolderOutlined';

const useStyles = makeStyles(() =>
  createStyles({
    box: {
      overflow: 'hidden'
    },
    title: {
      fontSize: '1.1rem',
      lineHeight: '1.3rem',
      fontWeight: 600,
      whiteSpace: 'nowrap',
      padding: '1rem'
    },
    cases: {
      justifyContent: 'space-around',
      height: '100%',
      position: 'relative',
      marginLeft: '0.5rem'
    },
    empty: {
      textAlign: 'center',
      marginBottom: '1rem',
      padding: '2rem',
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: '100%'
    },
    case: {
      height: '10%',
      minHeight: '60px',
      display: 'flex',
      alignItems: 'center',
      padding: '0 1rem',
      fontSize: '12px',
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: itemHoverColor
      }
    },
    separator: {
      padding: '0 0.5rem',
      fontSize: '0.9rem'
    },
    loadingWrapper: {
      height: '100%',
      display: 'flex',
      alignItems: 'center'
    }
  })
);

const RecentCases = () => {
  const classes = useStyles();
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(true);
  const [cases, setCases] = useState([] as any[]);

  useEffect(() => {
    setIsLoading(true);
    api.getLatestCases().then(({ data }) => {
      setCases(data.results);
      setIsLoading(false);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <BoxWrapper title="Recent cases" className={classes.box} noBorder>
      <div className={classes.cases}>
        {isLoading ? (
          <div className={classes.loadingWrapper}>
            <LoaderSpinner isLoading={isLoading} />
          </div>
        ) : (
          <>
            {cases.length ? (
              cases.map(({ id, name, customers, last_updated, created_at }) => (
                <div
                  onClick={() =>
                    history.push(
                      Routes.RISK_SUMMARY.MAIN.replace(':portfolio', id)
                    )
                  }
                  key={id}
                  className={classes.case}
                >
                  <div>
                    <div style={{ color: secondaryText }}>
                      <span className="dashboardLink">
                        {customers[customers.length - 1].display_name}
                      </span>
                      <span className={classes.separator}>|</span>
                      {name}
                    </div>
                    <div>
                      Last updated{' '}
                      <b>
                        {last_updated || created_at
                          ? moment(last_updated || created_at).fromNow()
                          : '-'}
                      </b>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className={classes.empty}>
                <CreateNewFolderIcon
                  htmlColor="#6b7280"
                  style={{ width: '36px', height: '36px' }}
                />
                <div style={{ fontWeight: 600 }}>No cases</div>
                <div style={{ color: '#6b7280' }}>
                  Get started by adding a new case.
                </div>
                <div
                  style={{
                    padding: '1rem 0rem 0rem'
                  }}
                >
                  <Button
                    onClick={() => {
                      history.push({
                        pathname: Routes.CASES,
                        state: { newCase: true }
                      });
                    }}
                  >
                    Add New Case
                  </Button>
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </BoxWrapper>
  );
};

export default RecentCases;
